import { Component, Input, OnInit } from '@angular/core';
import { MapLayers } from '@shared/utils/mappers/layers-map.model';
import { Icon } from '@types-custom/models/ui/icon-model';
import { IMapConventionsPropertiesModel } from '@types-custom/models/ui/map-conventions-model';

/*
** Map Conventions
** Render a Convention panel
*/
@Component({
  selector: 'sit-map-conventions',
  templateUrl: './map-conventions.component.html',
  styleUrls: ['./map-conventions.component.scss'],
})
export class MapConventionsComponent {
  @Input() layer: MapLayers | undefined;
  @Input() mapConventionsProperties: IMapConventionsPropertiesModel | undefined;
  Icon = Icon;

  get Legend() {

    if (!this.layer) return null;
    switch (this.layer) {
      case MapLayers.Situations:
        return this.mapConventionsProperties.properties.situationsConventions;
      case MapLayers.ParkingZone:
        return this.mapConventionsProperties.properties.parkingConventions;
      case MapLayers.ParkingSquarePMR:
        return this.mapConventionsProperties.properties.parkingPMRConventions;
      case MapLayers.ParkingZoneLoading:
        return this.mapConventionsProperties.properties.loadingZoneConv;
      case MapLayers.MatrixODsensor:
        return this.mapConventionsProperties.properties.matrizODConv;
        case MapLayers.MatrixODcamera:
        return this.mapConventionsProperties.properties.matrizODCameraConv;
      default:
        return null;
    }
  }

  onShowPanel() {
    this.mapConventionsProperties?.showPanel$?.value
      ? this.mapConventionsProperties?.showPanel$?.next(false)
      : this.mapConventionsProperties?.showPanel$?.next(true);
  }

  closePanel() {
    this.mapConventionsProperties?.showPanel$?.next(false);
  }
}
